export const PAYPAL_CHECKER_REQUEST = "PAYPAL_CHECKER_REQUEST";
export const PAYPAL_CHECKER_SUCCESS = "PAYPAL_CHECKER_SUCCESS ";
export const PAYPAL_CHECKER_ERROR = "PAYPAL_CHECKER_ERROR";
